import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { makeStyles } from "@material-ui/core/styles";
import s from "../createTournament.module.scss";

const useStyles = makeStyles(theme => ({
  tooltip: {
    backgroundColor: "#1a1a2e",
    color: "#ffffff",
    fontSize: "14px",
    padding: "12px 16px",
    maxWidth: "400px",
    border: "1px solid rgba(123, 97, 255, 0.3)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
    "& strong": {
      color: "#90caf9",
      fontWeight: 600,
    },
    "& a": {
      color: "#90caf9 !important",
    },
  },
  arrow: {
    color: "#1a1a2e",
    "&::before": {
      border: "1px solid rgba(123, 97, 255, 0.3)",
    },
  },
}));

const InfoTooltip = ({ content, placement = "top" }) => {
  const classes = useStyles();
  return (
    <Tooltip
      title={content}
      arrow
      placement={placement}
      interactive
      enterDelay={200}
      leaveDelay={200}
      classes={{
        tooltip: classes.tooltip,
        arrow: classes.arrow,
      }}
    >
      <HelpOutlineIcon className={s.tooltipIcon} />
    </Tooltip>
  );
};

export default InfoTooltip;

